import { LoaderState } from 'src/types/loader-state.enum';
import { useAccountSyncStatuses } from 'src/hooks/queries/accounts';
import AccountService from 'src/services/account.service';
import { useEffect, useState } from 'react';

export const useSyncingAccounts = (): { loaderState: LoaderState; isSyncingAccounts: boolean } => {
    const { data: syncStatuses } = useAccountSyncStatuses();
    const isSyncingAccounts: boolean = AccountService.isSyncingAccounts(syncStatuses);
    const [loaderState, setLoaderState] = useState<LoaderState>(null);

    useEffect(() => {
        if (isSyncingAccounts) {
            setLoaderState(LoaderState.LOADING);
        } else if (!isSyncingAccounts && loaderState === LoaderState.LOADING) {
            setLoaderState(LoaderState.FADE_IN);
        }
    }, [isSyncingAccounts]);

    return { loaderState, isSyncingAccounts };
};
